<div mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    <mat-icon class="w-25" style="height: 50px;" [svgIcon]="ghlIcon"></mat-icon>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="container-fluid p-2">
        <form [formGroup]="ghlForm" class="row">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>
                    Choose your target GHL calendar
                </mat-label>
                <mat-select formControlName="selectedCalendar" required>
                    <mat-option *ngFor="let calendar of calendars" [value]="calendar.id">
                        {{calendar.name}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="ghlForm.controls['selectedCalendar'].hasError('required')">You need to select a calendar</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Timezone</mat-label>
                <mat-error *ngIf="ghlForm.controls['timezone'].hasError('required')">You need to enter your timezone</mat-error>
                <mat-error *ngIf="ghlForm.controls['timezone'].hasError('timezone')">timezone is not valid</mat-error>
                <input matInput placeholder="Ex: America/New_York" formControlName="timezone" [matAutocomplete]="auto" required>
                <mat-autocomplete #auto="matAutocomplete">
                    @for (option of filteredOptions | async; track option) {
                      <mat-option [value]="option">{{option}}</mat-option>
                    }
                  </mat-autocomplete>
                <mat-hint>Enter the time zone for your appointments</mat-hint>
            </mat-form-field>
        </form>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" [disabled]="isLoading" color="warn">Close</button>
    <button mat-raised-button class="w-25" color="primary" [disabled]="!ghlForm.valid || isLoading" (click)="onFormSubmit()">
        <span *ngIf="!isLoading">
            Save
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>